"use strict";

angular.module('rmBlades', []);

require('./controller');